import * as t from 'utils/combinatorTypes';

export const combinators = t;

/**
 * makeOption
 * Creates a dropdown option for a combinator type.
 *
 * ```
 * makeOption(value, text, description)
 * ```
 */
export const makeOption = (value: string, text: string, description: string) => ({
  value,
  text,
  description,
});

const ANY = makeOption(t.OR, 'any', 'OR');
const ALL = makeOption(t.AND, 'all', 'AND');
const NONE = makeOption(t.NOT, 'none', 'NOT');

export const combinatorOptions = [ANY, ALL, NONE];
export const combinatorTextToValueMap = {
  [t.OR]: 'Any',
  [t.AND]: 'All',
  [t.NOT]: 'None',
};

export const segmentTopLabels = {
  [t.OR]: 'Must Have',
  [t.AND]: 'Must Have',
  [t.NOT]: "Can't Have",
};

export const segmentSubTopLabels = {
  [t.OR]: 'This',
  [t.AND]: 'This',
  [t.NOT]: 'Not This',
};

export const segmentLabels = {
  [t.OR]: 'Or',
  [t.AND]: 'And',
  [t.NOT]: 'Nor',
};

export default combinators;
